import { render, staticRenderFns } from "./CreateSaleModal.vue?vue&type=template&id=46162b86&scoped=true"
import script from "./CreateSaleModal.vue?vue&type=script&lang=ts"
export * from "./CreateSaleModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateSaleModal.vue?vue&type=style&index=0&id=46162b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46162b86",
  null
  
)

export default component.exports